/**
 * Browser download helpers for the Cari Hareketler exports. Each page builds a
 * MovementDoc (company + meta + data) and calls one of these.
 */
import { pdf } from '@react-pdf/renderer';
import { CariMovementsPDF } from '@/components/cari/cari-movements-pdf';
import { exportCariMovementsXlsx } from './export-cari-movements-xlsx';
import type { MovementDoc } from './cari-movements-doc';

function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export async function downloadMovementsPdf(doc: MovementDoc, filename: string): Promise<void> {
  // Each division prints its own letterhead logo (trading vs. turizm).
  const blob = await pdf(
    <CariMovementsPDF doc={doc} logoUrl={doc.company.logo ?? '/polatkan-logo.png'} />
  ).toBlob();
  saveBlob(blob, filename);
}

export async function downloadMovementsXlsx(doc: MovementDoc, filename: string): Promise<void> {
  await exportCariMovementsXlsx(doc, filename);
}
